export default __webpack_public_path__ + "static/media/surf.c51fda2a.png";